<div class="container landing-container post-page-wrapper">
  <div class="page-head">
    <div class="head-aside">
      <div class="multi-select-block">
        <ng-multiselect-dropdown [placeholder]="'Choose topic'" [settings]="dropdownSettings" [data]="dropdownList"
          [(ngModel)]="selectedItems">
        </ng-multiselect-dropdown>
      </div>
      <div class="level-select-dropbox">
        <div ngbDropdown class="d-inline-block">
          <button type="button" class="btn btn-level-select" id="dropdownLevelSelect" ngbDropdownToggle>
            <span class="text">Set Level</span>

            <span class="icon-wrap">
              <img src="./assets/images/ic-arrow-down-dark.svg" alt="Icon" />
            </span>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownLevelSelect">
            <button ngbDropdownItem aria-selected="true">
              <div class="level-li-inner theme-pink">
                <div>
                  <h5>Public</h5>
                  <p>Some explanation sub text info</p>
                </div>
                <span class="check-show"></span>
              </div>
            </button>
            <button ngbDropdownItem>
              <div class="level-li-inner theme-yellow">
                <div>
                  <h5>Follower</h5>
                  <p>Some explanation sub text info</p>
                </div>
                <span class="check-show"></span>
              </div>
            </button>
            <button ngbDropdownItem>
              <div class="level-li-inner theme-green">
                <div>
                  <h5>Connections</h5>
                  <p>Some explanation sub text info</p>
                </div>
                <span class="check-show"></span>
              </div>
            </button>
          </div>
        </div>
      </div>
      <div class="connection-st-grp">
        <button class="btn st-public" title="Public">
          <img src="./assets/images/ic-user-sm.svg" alt="Icon" />
          Public
        </button>
        <button class="btn st-followers d-none" title="Follower">
          <img src="./assets/images/ic-user-sm.svg" alt="Icon" />
          Followers
        </button>
        <button class="btn st-connections d-none" title="Connections">
          <img src="./assets/images/ic-user-sm.svg" alt="Icon" />
          Connections
        </button>
      </div>
    </div>
    <div class="head-end">
      <div class="btn-grps">
        <button class="btn btn-eye border-0" [class.st-active]="isEyeVisible" disabled>
          <img src="./assets/images/ic-eye-open.svg" alt="Icon" class="default-icon" />
          <img src="./assets/images/ic-eye-close.svg" alt="Icon" class="active-icon" />
        </button>
        <button class="btn" disabled title="Publish">Publish</button>
        <button class="btn">
          <img src="./assets/images/ic-save.svg" alt="Icon" />
        </button>
      </div>
    </div>
  </div>

  <div class="post-content-wrap">
    <div class="selected-chip-view-block">
      <button class="btn btn-outline-primary">Edit Details</button>
      <div class="time-span-info">
        <div class="tag-wrap">
          <span class="tag tag-success"> #Entertainment </span>
          <span class="tag tag-warning"> #Art </span>
          <span class="tag tag-success"> #Tech </span>
        </div>
        <p class="date-log">Jan 20</p>
      </div>
    </div>

    <!-- Add UI Block  -->
    <div class="add-ui-block">
      <div ngbDropdown>
        <button class="btn btn-add-item" ngbDropdownToggle>
          <img src="./assets/images/ic-add-white.svg" alt="Icon" id="dropdownBasic1" />
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="post-element-dropdown">
          <button ngbDropdownItem [dndDraggable] (dndStart)="onDragStart($event)">
            <img src="./assets/images/ic-drag-main-img.svg" alt="Icon" />
            <span class="link-text">Main Image</span>
          </button>
          <button ngbDropdownItem title="Header" [dndDraggable]>
            <img src="./assets/images/ic-drag-header.svg" alt="Icon" />
            <span class="link-text">Header</span>
          </button>
          <button ngbDropdownItem title="Image" [dndDraggable]>
            <img src="./assets/images/ic-drag-text.svg" alt="Icon" />
            <span class="link-text">Text </span>
          </button>
          <button ngbDropdownItem title="Video" [dndDraggable]>
            <img src="./assets/images/ic-drag-video.svg" alt="Icon" />
            <span class="link-text">Video</span>
          </button>
          <button ngbDropdownItem title="Link" [dndDraggable]>
            <img src="./assets/images/ic-drag-link.svg" alt="Icon" />
            <span class="link-text">Link</span>
          </button>
          <button ngbDropdownItem title="List" [dndDraggable]>
            <img src="./assets/images/ic-drag-list.svg" alt="Icon" />
            <span class="link-text">List</span>
          </button>
          <button ngbDropdownItem title="Subline" [dndDraggable]>
            <img src="./assets/images/ic-drag-subline.svg" alt="Icon" />
            <span class="link-text">Subline</span>
          </button>
          <button ngbDropdownItem title="Lead" [dndDraggable]>
            <img src="./assets/images/ic-drag-lead.svg" alt="Icon" />
            <span class="link-text">Lead</span>
          </button>
          <button ngbDropdownItem title="Quote" [dndDraggable]>
            <img src="./assets/images/ic-drag-quote.svg" alt="Icon" />
            <span class="link-text">Quote</span>
          </button>
        </div>
      </div>
    </div>



    <section dndDropzone (dndDragover)="onDragover($event)" (dndDrop)="onDrop($event)" class="dropzon-outer">
      <div class="post-comp-block header-block-spacing">
        <div class="drop-thumb-wrapper">
          <div class="header-drop-block">
            <h1>Cool title goes here</h1>
          </div>
        </div>
      </div>
      <!-- Subline Block  -->
      <div class="post-comp-block editable subline-block-spacing">
        <div class="drop-thumb-wrapper">
          <div class="subline-drop-block">
            <p class="subline-text">Add subline text</p>
            <div class="cta-block">
              <button class="btn" title="Edit">
                <!-- <img src="./assets/images/ic-setting.svg" alt="Icon" /> -->
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17.1 7.06436L15.7934 6.78032C15.6798 6.43246 15.5391 6.09317 15.3729 5.76633L16.0963 4.64118C16.2254 4.44015 16.197 4.17621 16.0282 4.00734L13.9927 1.97183C13.8238 1.80296 13.5599 1.77456 13.3588 1.90374L12.2337 2.62708C11.9068 2.46093 11.5675 2.32021 11.2197 2.20659L10.9356 0.899994C10.8849 0.666534 10.6782 0.5 10.4393 0.5H7.56072C7.32182 0.5 7.11507 0.666534 7.06436 0.899994L6.78032 2.20659C6.43246 2.32021 6.09317 2.46093 5.76633 2.62708L4.64118 1.90374C4.44015 1.77456 4.17621 1.80296 4.00734 1.97183L1.97183 4.00734C1.80296 4.17621 1.77456 4.44015 1.90374 4.64118L2.62708 5.76633C2.46093 6.09317 2.32021 6.43246 2.20659 6.78032L0.899994 7.06436C0.666534 7.1152 0.5 7.32182 0.5 7.56072V10.4393C0.5 10.6782 0.666534 10.8848 0.899994 10.9356L2.20659 11.2197C2.32021 11.5675 2.46093 11.9068 2.62708 12.2337L1.90374 13.3588C1.77456 13.5599 1.80296 13.8238 1.97183 13.9927L4.00734 16.0282C4.17621 16.197 4.44015 16.2254 4.64118 16.0963L5.76633 15.3729C6.09317 15.5391 6.43246 15.6798 6.78032 15.7934L7.06436 17.1C7.11507 17.3335 7.32182 17.5 7.56072 17.5H10.4393C10.6782 17.5 10.8849 17.3335 10.9356 17.1L11.2197 15.7934C11.5675 15.6798 11.9068 15.5391 12.2337 15.3729L13.3588 16.0963C13.5599 16.2254 13.8238 16.1972 13.9927 16.0282L16.0282 13.9927C16.197 13.8238 16.2254 13.5599 16.0963 13.3588L15.3729 12.2337C15.5391 11.9068 15.6798 11.5675 15.7934 11.2197L17.1 10.9356C17.3335 10.8848 17.5 10.6782 17.5 10.4393V7.56072C17.5 7.32182 17.3335 7.1152 17.1 7.06436ZM12.0478 9C12.0478 10.6805 10.6805 12.0478 9 12.0478C7.31948 12.0478 5.95219 10.6805 5.95219 9C5.95219 7.31948 7.31948 5.95219 9 5.95219C10.6805 5.95219 12.0478 7.31948 12.0478 9Z"
                    fill="currentColor" />
                </svg>
              </button>
              <button class="btn btn-delete" title="Delete" (click)="openDeleteSectionModal(deleteSectionModal)">
                <!-- <img src="./assets/images/ic-delete.svg" alt="Icon" /> -->
                <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.5938 1.75H8.1875V1.3125C8.1875 0.587617 7.59988 0 6.875 0H5.125C4.40012 0 3.8125 0.587617 3.8125 1.3125V1.75H1.40625C0.802199 1.75 0.3125 2.2397 0.3125 2.84375V3.71875C0.3125 3.96039 0.508363 4.15625 0.75 4.15625H11.25C11.4916 4.15625 11.6875 3.96039 11.6875 3.71875V2.84375C11.6875 2.2397 11.1978 1.75 10.5938 1.75ZM4.6875 1.3125C4.6875 1.07133 4.88383 0.875 5.125 0.875H6.875C7.11617 0.875 7.3125 1.07133 7.3125 1.3125V1.75H4.6875V1.3125Z"
                    fill="currentColor" />
                  <path fill-rule=" evenodd" clip-rule="evenodd"
                    d="M1.00602 5.17448C1.0023 5.09649 1.06451 5.03125 1.14257 5.03125H10.857C10.9351 5.03125 10.9973 5.09649 10.9936 5.17448L10.6327 12.7498C10.5993 13.4509 10.0234 14 9.3218 14H2.67781C1.97617 14 1.40031 13.4509 1.36696 12.7498L1.00602 5.17448ZM7.73068 8.30868L6.21478 8.2179L6.72427 7.9245L6.08254 6.87886L5.01157 8.76953L3.75658 8.05899L4.74215 6.31805C4.83876 6.14748 5.05976 6.0372 5.34667 6.0233C6.04802 5.98945 7.18511 6.00245 7.18511 6.00245L7.95012 7.22158L8.45758 6.93086L7.73068 8.30868ZM4.9071 10.1633L4.37251 9.84775L3.77875 10.9214L5.95139 10.9221V12.3642H3.95112C3.75454 12.3642 3.54967 12.2266 3.39658 11.9836C3.02204 11.3892 2.47266 10.3935 2.47266 10.3935L3.15675 9.12735L2.65377 8.82901L4.21135 8.78261L4.9071 10.1633ZM9.47243 9.97713L8.52093 8.21759L7.2525 8.90392L8.28513 10.8152L7.05839 10.8033L7.07677 10.2477L6.19812 11.452L6.97971 12.8L7.0028 12.2159L8.44226 12.2152C8.44226 12.2152 9.05686 11.2581 9.40093 10.6462C9.54236 10.3958 9.5659 10.1504 9.47243 9.97713Z"
                    fill="currentColor" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Text Block  -->
      <div class="post-comp-block editable">
        <div class="drop-thumb-wrapper">
          <!-- Add UI Block  -->
          <div class="text-drop-block">
            <div class="add-ui-block inside-block">
              <div ngbDropdown>
                <button class="btn btn-add-item" ngbDropdownToggle>
                  <!-- <img src="./assets/images/ic-add-white.svg" alt="Icon" id="dropdownBasic1"  /> -->
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="9" width="3" height="21" fill="currentColor" />
                    <rect y="12" width="3" height="21" transform="rotate(-90 0 12)" fill="currentColor" />
                  </svg>

                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="post-element-dropdown">
                  <button ngbDropdownItem [dndDraggable] (dndStart)="onDragStart($event)">
                    <img src="./assets/images/ic-drag-main-img.svg" alt="Icon" />
                    <span class="link-text">Main Image</span>
                  </button>
                  <button ngbDropdownItem title="Header" [dndDraggable]>
                    <img src="./assets/images/ic-drag-header.svg" alt="Icon" />
                    <span class="link-text">Header</span>
                  </button>
                  <button ngbDropdownItem title="Image" [dndDraggable]>
                    <img src="./assets/images/ic-drag-text.svg" alt="Icon" />
                    <span class="link-text">Text </span>
                  </button>
                  <button ngbDropdownItem title="Video" [dndDraggable]>
                    <img src="./assets/images/ic-drag-video.svg" alt="Icon" />
                    <span class="link-text">Video</span>
                  </button>
                  <button ngbDropdownItem title="Link" [dndDraggable]>
                    <img src="./assets/images/ic-drag-link.svg" alt="Icon" />
                    <span class="link-text">Link</span>
                  </button>
                  <button ngbDropdownItem title="List" [dndDraggable]>
                    <img src="./assets/images/ic-drag-list.svg" alt="Icon" />
                    <span class="link-text">List</span>
                  </button>
                  <button ngbDropdownItem title="Subline" [dndDraggable]>
                    <img src="./assets/images/ic-drag-subline.svg" alt="Icon" />
                    <span class="link-text">Subline</span>
                  </button>
                  <button ngbDropdownItem title="Lead" [dndDraggable]>
                    <img src="./assets/images/ic-drag-lead.svg" alt="Icon" />
                    <span class="link-text">Lead</span>
                  </button>
                  <button ngbDropdownItem title="Quote" [dndDraggable]>
                    <img src="./assets/images/ic-drag-quote.svg" alt="Icon" />
                    <span class="link-text">Quote</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="cus-tooltip tooltip-effect-1">
              <h4 class="tooltip-item">
                Fashion axe organic cronut lumbersexual cold-pressed, raclette
                slow-carb hot chicken kale chips tilde you probably haven't
                heard of them street art messenger bag poutine bicycle rights.
                Air plant poke polaroid roof party put a bird on it master
                cleanse. Echo park williamsburg blog vaporware, lumbersexual
                umami direct trade artisan 90's marfa heirloom pok pok salvia
                whatever. Tattooed lomo hammock sartorial. Tbh salvia
                knausgaard, pabst wayfarers twee williamsburg humblebrag 8-bit
                ethical mumblecore beard. Farm-to-table af meh palo santo
                fashion axe typewriter. Quinoa marfa fam echo park.
              </h4>
              <span class="tooltip-content">
                Fashion axe organic cronut lumbersexual cold-pressed, raclette
                slow-carb hot chicken kale chips tilde you probably haven't
                heard of them street art messenger bag poutine bicycle rights.
                Air plant poke polaroid roof party put a bird on it master
                cleanse. Echo park williamsburg blog vaporware, lumbersexual
                umami direct trade artisan 90's marfa heirloom pok pok salvia
                whatever. Tattooed lomo hammock sartorial. Tbh salvia
                knausgaard, pabst wayfarers twee williamsburg humblebrag 8-bit
                ethical mumblecore beard. Farm-to-table af meh palo santo
                fashion axe typewriter. Quinoa marfa fam echo park.
              </span>
            </div>
            <div class="cta-block">
              <button class="btn" title="Edit">
                <!-- <img src="./assets/images/ic-setting.svg" alt="Icon" /> -->
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17.1 7.06436L15.7934 6.78032C15.6798 6.43246 15.5391 6.09317 15.3729 5.76633L16.0963 4.64118C16.2254 4.44015 16.197 4.17621 16.0282 4.00734L13.9927 1.97183C13.8238 1.80296 13.5599 1.77456 13.3588 1.90374L12.2337 2.62708C11.9068 2.46093 11.5675 2.32021 11.2197 2.20659L10.9356 0.899994C10.8849 0.666534 10.6782 0.5 10.4393 0.5H7.56072C7.32182 0.5 7.11507 0.666534 7.06436 0.899994L6.78032 2.20659C6.43246 2.32021 6.09317 2.46093 5.76633 2.62708L4.64118 1.90374C4.44015 1.77456 4.17621 1.80296 4.00734 1.97183L1.97183 4.00734C1.80296 4.17621 1.77456 4.44015 1.90374 4.64118L2.62708 5.76633C2.46093 6.09317 2.32021 6.43246 2.20659 6.78032L0.899994 7.06436C0.666534 7.1152 0.5 7.32182 0.5 7.56072V10.4393C0.5 10.6782 0.666534 10.8848 0.899994 10.9356L2.20659 11.2197C2.32021 11.5675 2.46093 11.9068 2.62708 12.2337L1.90374 13.3588C1.77456 13.5599 1.80296 13.8238 1.97183 13.9927L4.00734 16.0282C4.17621 16.197 4.44015 16.2254 4.64118 16.0963L5.76633 15.3729C6.09317 15.5391 6.43246 15.6798 6.78032 15.7934L7.06436 17.1C7.11507 17.3335 7.32182 17.5 7.56072 17.5H10.4393C10.6782 17.5 10.8849 17.3335 10.9356 17.1L11.2197 15.7934C11.5675 15.6798 11.9068 15.5391 12.2337 15.3729L13.3588 16.0963C13.5599 16.2254 13.8238 16.1972 13.9927 16.0282L16.0282 13.9927C16.197 13.8238 16.2254 13.5599 16.0963 13.3588L15.3729 12.2337C15.5391 11.9068 15.6798 11.5675 15.7934 11.2197L17.1 10.9356C17.3335 10.8848 17.5 10.6782 17.5 10.4393V7.56072C17.5 7.32182 17.3335 7.1152 17.1 7.06436ZM12.0478 9C12.0478 10.6805 10.6805 12.0478 9 12.0478C7.31948 12.0478 5.95219 10.6805 5.95219 9C5.95219 7.31948 7.31948 5.95219 9 5.95219C10.6805 5.95219 12.0478 7.31948 12.0478 9Z"
                    fill="currentColor" />
                </svg>
              </button>
              <button class="btn btn-delete" title="Delete" (click)="openDeleteSectionModal(deleteSectionModal)">
                <!-- <img src="./assets/images/ic-delete.svg" alt="Icon" /> -->
                <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.5938 1.75H8.1875V1.3125C8.1875 0.587617 7.59988 0 6.875 0H5.125C4.40012 0 3.8125 0.587617 3.8125 1.3125V1.75H1.40625C0.802199 1.75 0.3125 2.2397 0.3125 2.84375V3.71875C0.3125 3.96039 0.508363 4.15625 0.75 4.15625H11.25C11.4916 4.15625 11.6875 3.96039 11.6875 3.71875V2.84375C11.6875 2.2397 11.1978 1.75 10.5938 1.75ZM4.6875 1.3125C4.6875 1.07133 4.88383 0.875 5.125 0.875H6.875C7.11617 0.875 7.3125 1.07133 7.3125 1.3125V1.75H4.6875V1.3125Z"
                    fill="currentColor" />
                  <path fill-rule=" evenodd" clip-rule="evenodd"
                    d="M1.00602 5.17448C1.0023 5.09649 1.06451 5.03125 1.14257 5.03125H10.857C10.9351 5.03125 10.9973 5.09649 10.9936 5.17448L10.6327 12.7498C10.5993 13.4509 10.0234 14 9.3218 14H2.67781C1.97617 14 1.40031 13.4509 1.36696 12.7498L1.00602 5.17448ZM7.73068 8.30868L6.21478 8.2179L6.72427 7.9245L6.08254 6.87886L5.01157 8.76953L3.75658 8.05899L4.74215 6.31805C4.83876 6.14748 5.05976 6.0372 5.34667 6.0233C6.04802 5.98945 7.18511 6.00245 7.18511 6.00245L7.95012 7.22158L8.45758 6.93086L7.73068 8.30868ZM4.9071 10.1633L4.37251 9.84775L3.77875 10.9214L5.95139 10.9221V12.3642H3.95112C3.75454 12.3642 3.54967 12.2266 3.39658 11.9836C3.02204 11.3892 2.47266 10.3935 2.47266 10.3935L3.15675 9.12735L2.65377 8.82901L4.21135 8.78261L4.9071 10.1633ZM9.47243 9.97713L8.52093 8.21759L7.2525 8.90392L8.28513 10.8152L7.05839 10.8033L7.07677 10.2477L6.19812 11.452L6.97971 12.8L7.0028 12.2159L8.44226 12.2152C8.44226 12.2152 9.05686 11.2581 9.40093 10.6462C9.54236 10.3958 9.5659 10.1504 9.47243 9.97713Z"
                    fill="currentColor" />
                </svg>
              </button>
              <button class="btn" title="discard changes" (click)="openDiscardChangesModal(discardChangesModal)">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"
                  style="width: 14px; height: 14px;">
                  <path
                    d="M1.06698 0.183065C0.822892 -0.0610214 0.427151 -0.0610215 0.183065 0.183064C-0.0610214 0.42715 -0.0610215 0.822892 0.183064 1.06698L4.1163 5.00021L0.18349 8.93302C-0.0605962 9.17711 -0.0605961 9.57285 0.18349 9.81694C0.427576 10.061 0.823317 10.061 1.0674 9.81694L5.00015 5.88418L8.9329 9.81694C9.17699 10.061 9.57273 10.061 9.81682 9.81694C10.0609 9.57285 10.0609 9.17711 9.81682 8.93302L5.88359 4.99979L9.81639 1.06698C10.0605 0.822892 10.0605 0.42715 9.81639 0.183064C9.57231 -0.0610215 9.17657 -0.0610214 8.93248 0.183065L4.99973 4.11582L1.06698 0.183065Z"
                    fill="currentColor" />
                </svg>

              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class=" post-comp-block">
                    <article-upload-image [blockElement]="newBlock"></article-upload-image>
                    <button class="btn btn-primary"
                      (click)="newBlock.isActiveForEdit=!newBlock.isActiveForEdit">edit</button>
            </div> -->
      <!-- This div will showup when their is no content -->
      <div class="temp-view-block">Drop your content here (Dropzone)</div>

      <!-- Placeholder content when hovering into dropzone -->
      <div dndPlaceholderRef class="placeholder-ref">Drop here</div>

      <div class="post-comp-block">
        <div class="drop-thumb-wrapper">
          <div class="default-img-drop-block">
            <input type="file" />
            <div class="upload-inner">
              <img src="./assets/images/ic-upload.svg" alt="Icon" />
              <span>Upload Your Image</span>
            </div>
          </div>
        </div>
      </div>
      <div class="post-comp-block">
        <div class="drop-thumb-wrapper">
          <div class="img-drop-block edit-mode">
            <div class="mockup-wrap">
              <img src="./assets/images/article-post-1.webp" alt="Mockup" class="main-img" />
            </div>
            <div class="image-action-block">
              <div class="btn-grps">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="crop-options" id="op-letterbox" checked />
                  <label class="form-check-label" for="op-letterbox">
                    Letterbox
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="crop-options" id="op-square" />
                  <label class="form-check-label" for="op-square">
                    Square
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="crop-options" id="op-one-by-two" />
                  <label class="form-check-label" for="op-one-by-two">
                    6:18
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="crop-options" id="op-one-by-three" />
                  <label class="form-check-label" for="op-one-by-three">
                    6:9
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="crop-options" id="op-four-into-three" />
                  <label class="form-check-label" for="op-four-into-three">
                    4x3
                  </label>
                </div>
              </div>
              <div class="save-edit-block">
                <button class="btn btn-action">
                  <img src="./assets/images/ic-crop.svg" alt="Icon" />
                  crop
                </button>
                <button class="btn btn-action">
                  <img src="./assets/images/ic-true.svg" alt="Icon" />
                  save
                </button>
                <button class="btn btn-action">
                  <img src="./assets/images/ic-false.svg" alt="Icon" />
                  cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="post-comp-block editable">
        <div class="drop-thumb-wrapper">
          <div class="header-drop-block">
            <h1>Cool title goes here</h1>
            <div class="NgxEditor__Wrapper">
              <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" [dropdownPlacement]="'bottom'">
              </ngx-editor-menu>
              <ngx-editor [editor]="editor" [ngModel]="html" [disabled]="false"
                [placeholder]="'Type here...'"></ngx-editor>
            </div>

            <div class="cta-block">
              <button class="btn" title="Edit">
                <!-- <img src="./assets/images/ic-setting.svg" alt="Icon" /> -->
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17.1 7.06436L15.7934 6.78032C15.6798 6.43246 15.5391 6.09317 15.3729 5.76633L16.0963 4.64118C16.2254 4.44015 16.197 4.17621 16.0282 4.00734L13.9927 1.97183C13.8238 1.80296 13.5599 1.77456 13.3588 1.90374L12.2337 2.62708C11.9068 2.46093 11.5675 2.32021 11.2197 2.20659L10.9356 0.899994C10.8849 0.666534 10.6782 0.5 10.4393 0.5H7.56072C7.32182 0.5 7.11507 0.666534 7.06436 0.899994L6.78032 2.20659C6.43246 2.32021 6.09317 2.46093 5.76633 2.62708L4.64118 1.90374C4.44015 1.77456 4.17621 1.80296 4.00734 1.97183L1.97183 4.00734C1.80296 4.17621 1.77456 4.44015 1.90374 4.64118L2.62708 5.76633C2.46093 6.09317 2.32021 6.43246 2.20659 6.78032L0.899994 7.06436C0.666534 7.1152 0.5 7.32182 0.5 7.56072V10.4393C0.5 10.6782 0.666534 10.8848 0.899994 10.9356L2.20659 11.2197C2.32021 11.5675 2.46093 11.9068 2.62708 12.2337L1.90374 13.3588C1.77456 13.5599 1.80296 13.8238 1.97183 13.9927L4.00734 16.0282C4.17621 16.197 4.44015 16.2254 4.64118 16.0963L5.76633 15.3729C6.09317 15.5391 6.43246 15.6798 6.78032 15.7934L7.06436 17.1C7.11507 17.3335 7.32182 17.5 7.56072 17.5H10.4393C10.6782 17.5 10.8849 17.3335 10.9356 17.1L11.2197 15.7934C11.5675 15.6798 11.9068 15.5391 12.2337 15.3729L13.3588 16.0963C13.5599 16.2254 13.8238 16.1972 13.9927 16.0282L16.0282 13.9927C16.197 13.8238 16.2254 13.5599 16.0963 13.3588L15.3729 12.2337C15.5391 11.9068 15.6798 11.5675 15.7934 11.2197L17.1 10.9356C17.3335 10.8848 17.5 10.6782 17.5 10.4393V7.56072C17.5 7.32182 17.3335 7.1152 17.1 7.06436ZM12.0478 9C12.0478 10.6805 10.6805 12.0478 9 12.0478C7.31948 12.0478 5.95219 10.6805 5.95219 9C5.95219 7.31948 7.31948 5.95219 9 5.95219C10.6805 5.95219 12.0478 7.31948 12.0478 9Z"
                    fill="currentColor" />
                </svg>

              </button>
              <button class=" btn btn-delete" title="Delete" (click)="openDeleteSectionModal(deleteSectionModal)">
                <!-- <img src="./assets/images/ic-delete.svg" alt="Icon" /> -->
                <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.5938 1.75H8.1875V1.3125C8.1875 0.587617 7.59988 0 6.875 0H5.125C4.40012 0 3.8125 0.587617 3.8125 1.3125V1.75H1.40625C0.802199 1.75 0.3125 2.2397 0.3125 2.84375V3.71875C0.3125 3.96039 0.508363 4.15625 0.75 4.15625H11.25C11.4916 4.15625 11.6875 3.96039 11.6875 3.71875V2.84375C11.6875 2.2397 11.1978 1.75 10.5938 1.75ZM4.6875 1.3125C4.6875 1.07133 4.88383 0.875 5.125 0.875H6.875C7.11617 0.875 7.3125 1.07133 7.3125 1.3125V1.75H4.6875V1.3125Z"
                    fill="currentColor" />
                  <path fill-rule=" evenodd" clip-rule="evenodd"
                    d="M1.00602 5.17448C1.0023 5.09649 1.06451 5.03125 1.14257 5.03125H10.857C10.9351 5.03125 10.9973 5.09649 10.9936 5.17448L10.6327 12.7498C10.5993 13.4509 10.0234 14 9.3218 14H2.67781C1.97617 14 1.40031 13.4509 1.36696 12.7498L1.00602 5.17448ZM7.73068 8.30868L6.21478 8.2179L6.72427 7.9245L6.08254 6.87886L5.01157 8.76953L3.75658 8.05899L4.74215 6.31805C4.83876 6.14748 5.05976 6.0372 5.34667 6.0233C6.04802 5.98945 7.18511 6.00245 7.18511 6.00245L7.95012 7.22158L8.45758 6.93086L7.73068 8.30868ZM4.9071 10.1633L4.37251 9.84775L3.77875 10.9214L5.95139 10.9221V12.3642H3.95112C3.75454 12.3642 3.54967 12.2266 3.39658 11.9836C3.02204 11.3892 2.47266 10.3935 2.47266 10.3935L3.15675 9.12735L2.65377 8.82901L4.21135 8.78261L4.9071 10.1633ZM9.47243 9.97713L8.52093 8.21759L7.2525 8.90392L8.28513 10.8152L7.05839 10.8033L7.07677 10.2477L6.19812 11.452L6.97971 12.8L7.0028 12.2159L8.44226 12.2152C8.44226 12.2152 9.05686 11.2581 9.40093 10.6462C9.54236 10.3958 9.5659 10.1504 9.47243 9.97713Z"
                    fill="currentColor" />
                </svg>


              </button>
            </div>
          </div>
        </div>
      </div>


      <!-- Quote Block  -->
      <div class="post-comp-block editable">
        <div class="drop-thumb-wrapper">
          <div class="quote-drop-block">
            <p class="quote-text">
              Gentrify pour-over meditation mlkshk. Fixie ugh food truck,
              farm-to-table single-origin coffee vinyl put a bird on it hammock.
              Ugh taiyaki wayfarers viral 3 wolf moon. Keffiyeh chicharrones
              tattooed blue bottle cornhole fanny pack selfies raw denim viral
              gentrify semiotics cronut vegan.
            </p>
            <div class="cta-block">
              <button class="btn" title="Edit">
                <!-- <img src="./assets/images/ic-setting.svg" alt="Icon" /> -->
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17.1 7.06436L15.7934 6.78032C15.6798 6.43246 15.5391 6.09317 15.3729 5.76633L16.0963 4.64118C16.2254 4.44015 16.197 4.17621 16.0282 4.00734L13.9927 1.97183C13.8238 1.80296 13.5599 1.77456 13.3588 1.90374L12.2337 2.62708C11.9068 2.46093 11.5675 2.32021 11.2197 2.20659L10.9356 0.899994C10.8849 0.666534 10.6782 0.5 10.4393 0.5H7.56072C7.32182 0.5 7.11507 0.666534 7.06436 0.899994L6.78032 2.20659C6.43246 2.32021 6.09317 2.46093 5.76633 2.62708L4.64118 1.90374C4.44015 1.77456 4.17621 1.80296 4.00734 1.97183L1.97183 4.00734C1.80296 4.17621 1.77456 4.44015 1.90374 4.64118L2.62708 5.76633C2.46093 6.09317 2.32021 6.43246 2.20659 6.78032L0.899994 7.06436C0.666534 7.1152 0.5 7.32182 0.5 7.56072V10.4393C0.5 10.6782 0.666534 10.8848 0.899994 10.9356L2.20659 11.2197C2.32021 11.5675 2.46093 11.9068 2.62708 12.2337L1.90374 13.3588C1.77456 13.5599 1.80296 13.8238 1.97183 13.9927L4.00734 16.0282C4.17621 16.197 4.44015 16.2254 4.64118 16.0963L5.76633 15.3729C6.09317 15.5391 6.43246 15.6798 6.78032 15.7934L7.06436 17.1C7.11507 17.3335 7.32182 17.5 7.56072 17.5H10.4393C10.6782 17.5 10.8849 17.3335 10.9356 17.1L11.2197 15.7934C11.5675 15.6798 11.9068 15.5391 12.2337 15.3729L13.3588 16.0963C13.5599 16.2254 13.8238 16.1972 13.9927 16.0282L16.0282 13.9927C16.197 13.8238 16.2254 13.5599 16.0963 13.3588L15.3729 12.2337C15.5391 11.9068 15.6798 11.5675 15.7934 11.2197L17.1 10.9356C17.3335 10.8848 17.5 10.6782 17.5 10.4393V7.56072C17.5 7.32182 17.3335 7.1152 17.1 7.06436ZM12.0478 9C12.0478 10.6805 10.6805 12.0478 9 12.0478C7.31948 12.0478 5.95219 10.6805 5.95219 9C5.95219 7.31948 7.31948 5.95219 9 5.95219C10.6805 5.95219 12.0478 7.31948 12.0478 9Z"
                    fill="currentColor" />
                </svg>
              </button>
              <button class="btn btn-delete" title="Delete" (click)="openDeleteSectionModal(deleteSectionModal)">
                <!-- <img src="./assets/images/ic-delete.svg" alt="Icon" /> -->
                <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.5938 1.75H8.1875V1.3125C8.1875 0.587617 7.59988 0 6.875 0H5.125C4.40012 0 3.8125 0.587617 3.8125 1.3125V1.75H1.40625C0.802199 1.75 0.3125 2.2397 0.3125 2.84375V3.71875C0.3125 3.96039 0.508363 4.15625 0.75 4.15625H11.25C11.4916 4.15625 11.6875 3.96039 11.6875 3.71875V2.84375C11.6875 2.2397 11.1978 1.75 10.5938 1.75ZM4.6875 1.3125C4.6875 1.07133 4.88383 0.875 5.125 0.875H6.875C7.11617 0.875 7.3125 1.07133 7.3125 1.3125V1.75H4.6875V1.3125Z"
                    fill="currentColor" />
                  <path fill-rule=" evenodd" clip-rule="evenodd"
                    d="M1.00602 5.17448C1.0023 5.09649 1.06451 5.03125 1.14257 5.03125H10.857C10.9351 5.03125 10.9973 5.09649 10.9936 5.17448L10.6327 12.7498C10.5993 13.4509 10.0234 14 9.3218 14H2.67781C1.97617 14 1.40031 13.4509 1.36696 12.7498L1.00602 5.17448ZM7.73068 8.30868L6.21478 8.2179L6.72427 7.9245L6.08254 6.87886L5.01157 8.76953L3.75658 8.05899L4.74215 6.31805C4.83876 6.14748 5.05976 6.0372 5.34667 6.0233C6.04802 5.98945 7.18511 6.00245 7.18511 6.00245L7.95012 7.22158L8.45758 6.93086L7.73068 8.30868ZM4.9071 10.1633L4.37251 9.84775L3.77875 10.9214L5.95139 10.9221V12.3642H3.95112C3.75454 12.3642 3.54967 12.2266 3.39658 11.9836C3.02204 11.3892 2.47266 10.3935 2.47266 10.3935L3.15675 9.12735L2.65377 8.82901L4.21135 8.78261L4.9071 10.1633ZM9.47243 9.97713L8.52093 8.21759L7.2525 8.90392L8.28513 10.8152L7.05839 10.8033L7.07677 10.2477L6.19812 11.452L6.97971 12.8L7.0028 12.2159L8.44226 12.2152C8.44226 12.2152 9.05686 11.2581 9.40093 10.6462C9.54236 10.3958 9.5659 10.1504 9.47243 9.97713Z"
                    fill="currentColor" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>



      <!-- lead Block  -->
      <div class="post-comp-block editable">
        <div class="drop-thumb-wrapper">
          <div class="lead-drop-block">
            <p class="lead-text">
              Fashion axe organic cronut lumbersexual cold-pressed, raclette
              slow-carb hot chicken kale chips tilde you probably haven't heard
              of them street art messenger bag poutine bicycle rights. Air plant
              poke polaroid roof party put a bird on it master cleanse. Echo
              park williamsburg blog vaporware, lumbersexual umami direct trade
              artisan 90's marfa heirloom pok pok salvia whatever. Tattooed lomo
              hammock sartorial. Tbh salvia knausgaard, pabst wayfarers twee
              williamsburg humblebrag 8-bit ethical mumblecore beard.
              Farm-to-table af meh palo santo fashion axe typewriter. Quinoa
              marfa fam echo park.
            </p>
            <div class="cta-block">
              <button class="btn" title="Edit">
                <!-- <img src="./assets/images/ic-setting.svg" alt="Icon" /> -->
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17.1 7.06436L15.7934 6.78032C15.6798 6.43246 15.5391 6.09317 15.3729 5.76633L16.0963 4.64118C16.2254 4.44015 16.197 4.17621 16.0282 4.00734L13.9927 1.97183C13.8238 1.80296 13.5599 1.77456 13.3588 1.90374L12.2337 2.62708C11.9068 2.46093 11.5675 2.32021 11.2197 2.20659L10.9356 0.899994C10.8849 0.666534 10.6782 0.5 10.4393 0.5H7.56072C7.32182 0.5 7.11507 0.666534 7.06436 0.899994L6.78032 2.20659C6.43246 2.32021 6.09317 2.46093 5.76633 2.62708L4.64118 1.90374C4.44015 1.77456 4.17621 1.80296 4.00734 1.97183L1.97183 4.00734C1.80296 4.17621 1.77456 4.44015 1.90374 4.64118L2.62708 5.76633C2.46093 6.09317 2.32021 6.43246 2.20659 6.78032L0.899994 7.06436C0.666534 7.1152 0.5 7.32182 0.5 7.56072V10.4393C0.5 10.6782 0.666534 10.8848 0.899994 10.9356L2.20659 11.2197C2.32021 11.5675 2.46093 11.9068 2.62708 12.2337L1.90374 13.3588C1.77456 13.5599 1.80296 13.8238 1.97183 13.9927L4.00734 16.0282C4.17621 16.197 4.44015 16.2254 4.64118 16.0963L5.76633 15.3729C6.09317 15.5391 6.43246 15.6798 6.78032 15.7934L7.06436 17.1C7.11507 17.3335 7.32182 17.5 7.56072 17.5H10.4393C10.6782 17.5 10.8849 17.3335 10.9356 17.1L11.2197 15.7934C11.5675 15.6798 11.9068 15.5391 12.2337 15.3729L13.3588 16.0963C13.5599 16.2254 13.8238 16.1972 13.9927 16.0282L16.0282 13.9927C16.197 13.8238 16.2254 13.5599 16.0963 13.3588L15.3729 12.2337C15.5391 11.9068 15.6798 11.5675 15.7934 11.2197L17.1 10.9356C17.3335 10.8848 17.5 10.6782 17.5 10.4393V7.56072C17.5 7.32182 17.3335 7.1152 17.1 7.06436ZM12.0478 9C12.0478 10.6805 10.6805 12.0478 9 12.0478C7.31948 12.0478 5.95219 10.6805 5.95219 9C5.95219 7.31948 7.31948 5.95219 9 5.95219C10.6805 5.95219 12.0478 7.31948 12.0478 9Z"
                    fill="currentColor" />
                </svg>
              </button>
              <button class="btn btn-delete" title="Delete" (click)="openDeleteSectionModal(deleteSectionModal)">
                <!-- <img src="./assets/images/ic-delete.svg" alt="Icon" /> -->
                <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.5938 1.75H8.1875V1.3125C8.1875 0.587617 7.59988 0 6.875 0H5.125C4.40012 0 3.8125 0.587617 3.8125 1.3125V1.75H1.40625C0.802199 1.75 0.3125 2.2397 0.3125 2.84375V3.71875C0.3125 3.96039 0.508363 4.15625 0.75 4.15625H11.25C11.4916 4.15625 11.6875 3.96039 11.6875 3.71875V2.84375C11.6875 2.2397 11.1978 1.75 10.5938 1.75ZM4.6875 1.3125C4.6875 1.07133 4.88383 0.875 5.125 0.875H6.875C7.11617 0.875 7.3125 1.07133 7.3125 1.3125V1.75H4.6875V1.3125Z"
                    fill="currentColor" />
                  <path fill-rule=" evenodd" clip-rule="evenodd"
                    d="M1.00602 5.17448C1.0023 5.09649 1.06451 5.03125 1.14257 5.03125H10.857C10.9351 5.03125 10.9973 5.09649 10.9936 5.17448L10.6327 12.7498C10.5993 13.4509 10.0234 14 9.3218 14H2.67781C1.97617 14 1.40031 13.4509 1.36696 12.7498L1.00602 5.17448ZM7.73068 8.30868L6.21478 8.2179L6.72427 7.9245L6.08254 6.87886L5.01157 8.76953L3.75658 8.05899L4.74215 6.31805C4.83876 6.14748 5.05976 6.0372 5.34667 6.0233C6.04802 5.98945 7.18511 6.00245 7.18511 6.00245L7.95012 7.22158L8.45758 6.93086L7.73068 8.30868ZM4.9071 10.1633L4.37251 9.84775L3.77875 10.9214L5.95139 10.9221V12.3642H3.95112C3.75454 12.3642 3.54967 12.2266 3.39658 11.9836C3.02204 11.3892 2.47266 10.3935 2.47266 10.3935L3.15675 9.12735L2.65377 8.82901L4.21135 8.78261L4.9071 10.1633ZM9.47243 9.97713L8.52093 8.21759L7.2525 8.90392L8.28513 10.8152L7.05839 10.8033L7.07677 10.2477L6.19812 11.452L6.97971 12.8L7.0028 12.2159L8.44226 12.2152C8.44226 12.2152 9.05686 11.2581 9.40093 10.6462C9.54236 10.3958 9.5659 10.1504 9.47243 9.97713Z"
                    fill="currentColor" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Video Block  -->
      <div class="post-comp-block editable">
        <div class="drop-thumb-wrapper">
          <div class="video-drop-block">
            <!-- <div class="video-input-block">
                            <input type="text" class="form-control" placeholder="Video Link Here...">
                        </div> -->
            <div class="video-block-default">
              <!-- <img src="./assets/images/ic-video.svg" alt="Icon"> -->
              <input type="text" class="form-control" placeholder="Enter Video URL" />
            </div>
            <div class="video-view-block">
              <video data-testid="video-asset" style="width: 100%; max-width: 100%"
                src="https://media.istockphoto.com/id/1340761090/video/chefs-sous-chefs-and-kitchen-staff-working-at-their-stations-in-a-gourmet-restaurant.mp4?s=mp4-640x640-is&amp;k=20&amp;c=5vnFI7XNC0hPGRA0QFNp1ArvxFLYOlqf7UqOgSAMoEs="
                alt="More About Restuarant" controls="" controlslist="nodownload" autoplay="" loop=""></video>
            </div>
            <div class="cta-block">
              <button class="btn" title="Edit">
                <!-- <img src="./assets/images/ic-setting.svg" alt="Icon" /> -->
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17.1 7.06436L15.7934 6.78032C15.6798 6.43246 15.5391 6.09317 15.3729 5.76633L16.0963 4.64118C16.2254 4.44015 16.197 4.17621 16.0282 4.00734L13.9927 1.97183C13.8238 1.80296 13.5599 1.77456 13.3588 1.90374L12.2337 2.62708C11.9068 2.46093 11.5675 2.32021 11.2197 2.20659L10.9356 0.899994C10.8849 0.666534 10.6782 0.5 10.4393 0.5H7.56072C7.32182 0.5 7.11507 0.666534 7.06436 0.899994L6.78032 2.20659C6.43246 2.32021 6.09317 2.46093 5.76633 2.62708L4.64118 1.90374C4.44015 1.77456 4.17621 1.80296 4.00734 1.97183L1.97183 4.00734C1.80296 4.17621 1.77456 4.44015 1.90374 4.64118L2.62708 5.76633C2.46093 6.09317 2.32021 6.43246 2.20659 6.78032L0.899994 7.06436C0.666534 7.1152 0.5 7.32182 0.5 7.56072V10.4393C0.5 10.6782 0.666534 10.8848 0.899994 10.9356L2.20659 11.2197C2.32021 11.5675 2.46093 11.9068 2.62708 12.2337L1.90374 13.3588C1.77456 13.5599 1.80296 13.8238 1.97183 13.9927L4.00734 16.0282C4.17621 16.197 4.44015 16.2254 4.64118 16.0963L5.76633 15.3729C6.09317 15.5391 6.43246 15.6798 6.78032 15.7934L7.06436 17.1C7.11507 17.3335 7.32182 17.5 7.56072 17.5H10.4393C10.6782 17.5 10.8849 17.3335 10.9356 17.1L11.2197 15.7934C11.5675 15.6798 11.9068 15.5391 12.2337 15.3729L13.3588 16.0963C13.5599 16.2254 13.8238 16.1972 13.9927 16.0282L16.0282 13.9927C16.197 13.8238 16.2254 13.5599 16.0963 13.3588L15.3729 12.2337C15.5391 11.9068 15.6798 11.5675 15.7934 11.2197L17.1 10.9356C17.3335 10.8848 17.5 10.6782 17.5 10.4393V7.56072C17.5 7.32182 17.3335 7.1152 17.1 7.06436ZM12.0478 9C12.0478 10.6805 10.6805 12.0478 9 12.0478C7.31948 12.0478 5.95219 10.6805 5.95219 9C5.95219 7.31948 7.31948 5.95219 9 5.95219C10.6805 5.95219 12.0478 7.31948 12.0478 9Z"
                    fill="currentColor" />
                </svg>
              </button>
              <button class="btn btn-delete" title="Delete" (click)="openDeleteSectionModal(deleteSectionModal)">
                <!-- <img src="./assets/images/ic-delete.svg" alt="Icon" /> -->
                <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.5938 1.75H8.1875V1.3125C8.1875 0.587617 7.59988 0 6.875 0H5.125C4.40012 0 3.8125 0.587617 3.8125 1.3125V1.75H1.40625C0.802199 1.75 0.3125 2.2397 0.3125 2.84375V3.71875C0.3125 3.96039 0.508363 4.15625 0.75 4.15625H11.25C11.4916 4.15625 11.6875 3.96039 11.6875 3.71875V2.84375C11.6875 2.2397 11.1978 1.75 10.5938 1.75ZM4.6875 1.3125C4.6875 1.07133 4.88383 0.875 5.125 0.875H6.875C7.11617 0.875 7.3125 1.07133 7.3125 1.3125V1.75H4.6875V1.3125Z"
                    fill="currentColor" />
                  <path fill-rule=" evenodd" clip-rule="evenodd"
                    d="M1.00602 5.17448C1.0023 5.09649 1.06451 5.03125 1.14257 5.03125H10.857C10.9351 5.03125 10.9973 5.09649 10.9936 5.17448L10.6327 12.7498C10.5993 13.4509 10.0234 14 9.3218 14H2.67781C1.97617 14 1.40031 13.4509 1.36696 12.7498L1.00602 5.17448ZM7.73068 8.30868L6.21478 8.2179L6.72427 7.9245L6.08254 6.87886L5.01157 8.76953L3.75658 8.05899L4.74215 6.31805C4.83876 6.14748 5.05976 6.0372 5.34667 6.0233C6.04802 5.98945 7.18511 6.00245 7.18511 6.00245L7.95012 7.22158L8.45758 6.93086L7.73068 8.30868ZM4.9071 10.1633L4.37251 9.84775L3.77875 10.9214L5.95139 10.9221V12.3642H3.95112C3.75454 12.3642 3.54967 12.2266 3.39658 11.9836C3.02204 11.3892 2.47266 10.3935 2.47266 10.3935L3.15675 9.12735L2.65377 8.82901L4.21135 8.78261L4.9071 10.1633ZM9.47243 9.97713L8.52093 8.21759L7.2525 8.90392L8.28513 10.8152L7.05839 10.8033L7.07677 10.2477L6.19812 11.452L6.97971 12.8L7.0028 12.2159L8.44226 12.2152C8.44226 12.2152 9.05686 11.2581 9.40093 10.6462C9.54236 10.3958 9.5659 10.1504 9.47243 9.97713Z"
                    fill="currentColor" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Image Grid Layout Block  -->
      <div class="post-comp-block editable">
        <div class="drop-thumb-wrapper">
          <div class="img-grid-block">
            <div class="layout-wrap type-1 animation-on">
              <div class="layer-div">
                <div class="upload-outer d-none">
                  <input type="file" />
                  <div class="upload-inner">
                    <img src="./assets/images/ic-upload.svg" alt="Icon" />
                    <span>Upload Your Image</span>
                  </div>
                </div>
                <img src="./assets/images/layout-demo-1.webp" alt="Image" />
              </div>
              <div class="layer-div">
                <div class="upload-outer d-none">
                  <input type="file" />
                  <div class="upload-inner">
                    <img src="./assets/images/ic-upload.svg" alt="Icon" />
                    <span>Upload Your Image</span>
                  </div>
                </div>
                <img src="./assets/images/layout-demo-2.jpg" alt="Image" />
              </div>
              <div class="layer-div">
                <div class="upload-outer d-none">
                  <input type="file" />
                  <div class="upload-inner">
                    <img src="./assets/images/ic-upload.svg" alt="Icon" />
                    <span>Upload Your Image</span>
                  </div>
                </div>
                <img src="./assets/images/layout-demo-3.jpg" alt="Image" />
              </div>
              <div class="layer-div">
                <div class="upload-outer d-none">
                  <input type="file" />
                  <div class="upload-inner">
                    <img src="./assets/images/ic-upload.svg" alt="Icon" />
                    <span>Upload Your Image</span>
                  </div>
                </div>
                <img src="./assets/images/layout-demo-4.jpg" alt="Image" />
              </div>
            </div>

            <div class="cta-block">
              <button class="btn btn-choose-grid" title="Edit" id="choose-layout"
                (click)="openLayoutSelectModal(layoutSelect)">
                <!-- <img src="./assets/images/ic-setting.svg" alt="Icon" /> -->
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17.1 7.06436L15.7934 6.78032C15.6798 6.43246 15.5391 6.09317 15.3729 5.76633L16.0963 4.64118C16.2254 4.44015 16.197 4.17621 16.0282 4.00734L13.9927 1.97183C13.8238 1.80296 13.5599 1.77456 13.3588 1.90374L12.2337 2.62708C11.9068 2.46093 11.5675 2.32021 11.2197 2.20659L10.9356 0.899994C10.8849 0.666534 10.6782 0.5 10.4393 0.5H7.56072C7.32182 0.5 7.11507 0.666534 7.06436 0.899994L6.78032 2.20659C6.43246 2.32021 6.09317 2.46093 5.76633 2.62708L4.64118 1.90374C4.44015 1.77456 4.17621 1.80296 4.00734 1.97183L1.97183 4.00734C1.80296 4.17621 1.77456 4.44015 1.90374 4.64118L2.62708 5.76633C2.46093 6.09317 2.32021 6.43246 2.20659 6.78032L0.899994 7.06436C0.666534 7.1152 0.5 7.32182 0.5 7.56072V10.4393C0.5 10.6782 0.666534 10.8848 0.899994 10.9356L2.20659 11.2197C2.32021 11.5675 2.46093 11.9068 2.62708 12.2337L1.90374 13.3588C1.77456 13.5599 1.80296 13.8238 1.97183 13.9927L4.00734 16.0282C4.17621 16.197 4.44015 16.2254 4.64118 16.0963L5.76633 15.3729C6.09317 15.5391 6.43246 15.6798 6.78032 15.7934L7.06436 17.1C7.11507 17.3335 7.32182 17.5 7.56072 17.5H10.4393C10.6782 17.5 10.8849 17.3335 10.9356 17.1L11.2197 15.7934C11.5675 15.6798 11.9068 15.5391 12.2337 15.3729L13.3588 16.0963C13.5599 16.2254 13.8238 16.1972 13.9927 16.0282L16.0282 13.9927C16.197 13.8238 16.2254 13.5599 16.0963 13.3588L15.3729 12.2337C15.5391 11.9068 15.6798 11.5675 15.7934 11.2197L17.1 10.9356C17.3335 10.8848 17.5 10.6782 17.5 10.4393V7.56072C17.5 7.32182 17.3335 7.1152 17.1 7.06436ZM12.0478 9C12.0478 10.6805 10.6805 12.0478 9 12.0478C7.31948 12.0478 5.95219 10.6805 5.95219 9C5.95219 7.31948 7.31948 5.95219 9 5.95219C10.6805 5.95219 12.0478 7.31948 12.0478 9Z"
                    fill="currentColor" />
                </svg>
              </button>
              <button class="btn" title="Save">
                <!-- <img src="./assets/images/ic-save-white.svg" alt="Icon" /> -->
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_2583_337)">
                    <path d="M11.636 11.6367H4.36328V13.0912H11.636V11.6367Z" fill="currentColor" />
                    <path d="M4.36328 14.5459V15.2731V16.0004H11.636V15.2731V14.5459H4.36328Z" fill="currentColor" />
                    <path
                      d="M15.8543 4.18259L12.932 0.290625C12.7946 0.107688 12.5792 0 12.3504 0H11.1515V0.727281V1.45456V6.06063C11.1515 6.46222 10.8259 6.78791 10.4242 6.78791H3.63637C3.23472 6.78791 2.90909 6.46222 2.90909 6.06063V1.45453V0.727281V0H0.727281C0.325625 0 0 0.325688 0 0.727281V15.2727C0 15.6743 0.325625 16 0.727281 16H2.90909V15.2727V14.5454V13.8182V10.9091C2.90909 10.5074 3.23472 10.1818 3.63637 10.1818H12.3637C12.7653 10.1818 13.0909 10.5073 13.0909 10.9091V13.8182V14.5454V15.2727V16H15.2727C15.6744 16 16 15.6743 16 15.2727V4.61928C16 4.46181 15.9488 4.3085 15.8543 4.18259Z"
                      fill="currentColor" />
                    <path d="M4.36328 0V0.727281V1.45453V5.33334H9.69663V1.45453V0.727281V0H4.36328Z"
                      fill="currentColor" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2583_337">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

              </button>
              <button class="btn" title="Edit layout">
                <!-- <img src="./assets/images/ic-layout.svg" alt="Icon" /> -->
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0 0.9V17.1C0 17.3387 0.0948211 17.5676 0.263604 17.7364C0.432387 17.9052 0.661305 18 0.9 18H17.1C17.3387 18 17.5676 17.9052 17.7364 17.7364C17.9052 17.5676 18 17.3387 18 17.1V0.9C18 0.661305 17.9052 0.432387 17.7364 0.263604C17.5676 0.0948211 17.3387 0 17.1 0H0.9C0.661305 0 0.432387 0.0948211 0.263604 0.263604C0.0948211 0.432387 0 0.661305 0 0.9ZM9.9 1.8H16.2V8.1H9.9V1.8ZM9.9 9.9H16.2V16.2H9.9V9.9ZM1.8 1.8H8.1V16.2H1.8V1.8Z"
                    fill="currentColor" />
                </svg>

              </button>
              <button class=" btn btn-delete" title="Delete" (click)="openDeleteSectionModal(deleteSectionModal)">
                <!-- <img src="./assets/images/ic-delete.svg" alt="Icon" /> -->
                <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.5938 1.75H8.1875V1.3125C8.1875 0.587617 7.59988 0 6.875 0H5.125C4.40012 0 3.8125 0.587617 3.8125 1.3125V1.75H1.40625C0.802199 1.75 0.3125 2.2397 0.3125 2.84375V3.71875C0.3125 3.96039 0.508363 4.15625 0.75 4.15625H11.25C11.4916 4.15625 11.6875 3.96039 11.6875 3.71875V2.84375C11.6875 2.2397 11.1978 1.75 10.5938 1.75ZM4.6875 1.3125C4.6875 1.07133 4.88383 0.875 5.125 0.875H6.875C7.11617 0.875 7.3125 1.07133 7.3125 1.3125V1.75H4.6875V1.3125Z"
                    fill="currentColor" />
                  <path fill-rule=" evenodd" clip-rule="evenodd"
                    d="M1.00602 5.17448C1.0023 5.09649 1.06451 5.03125 1.14257 5.03125H10.857C10.9351 5.03125 10.9973 5.09649 10.9936 5.17448L10.6327 12.7498C10.5993 13.4509 10.0234 14 9.3218 14H2.67781C1.97617 14 1.40031 13.4509 1.36696 12.7498L1.00602 5.17448ZM7.73068 8.30868L6.21478 8.2179L6.72427 7.9245L6.08254 6.87886L5.01157 8.76953L3.75658 8.05899L4.74215 6.31805C4.83876 6.14748 5.05976 6.0372 5.34667 6.0233C6.04802 5.98945 7.18511 6.00245 7.18511 6.00245L7.95012 7.22158L8.45758 6.93086L7.73068 8.30868ZM4.9071 10.1633L4.37251 9.84775L3.77875 10.9214L5.95139 10.9221V12.3642H3.95112C3.75454 12.3642 3.54967 12.2266 3.39658 11.9836C3.02204 11.3892 2.47266 10.3935 2.47266 10.3935L3.15675 9.12735L2.65377 8.82901L4.21135 8.78261L4.9071 10.1633ZM9.47243 9.97713L8.52093 8.21759L7.2525 8.90392L8.28513 10.8152L7.05839 10.8033L7.07677 10.2477L6.19812 11.452L6.97971 12.8L7.0028 12.2159L8.44226 12.2152C8.44226 12.2152 9.05686 11.2581 9.40093 10.6462C9.54236 10.3958 9.5659 10.1504 9.47243 9.97713Z"
                    fill="currentColor" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Image Grid Layout Block  -->
      <div class="post-comp-block editable">
        <div class="drop-thumb-wrapper">
          <div class="img-grid-block">
            <div class="layout-wrap type-1 animation-on">
              <div class="layer-div">
                <div class="upload-outer d-none">
                  <input type="file" />
                  <div class="upload-inner">
                    <img src="./assets/images/ic-upload.svg" alt="Icon" />
                    <span>Upload Your Image</span>
                  </div>
                </div>
                <img src="./assets/images/layout-demo-1.webp" alt="Image" class="big-img" />
              </div>
              <div class="layer-div">
                <div class="upload-outer d-none">
                  <input type="file" />
                  <div class="upload-inner">
                    <img src="./assets/images/ic-upload.svg" alt="Icon" />
                    <span>Upload Your Image</span>
                  </div>
                </div>
                <img src="./assets/images/layout-demo-2.jpg" alt="Image" class="small-img"
                  (click)="swapImages($event)" />
              </div>
              <div class="layer-div">
                <div class="upload-outer d-none">
                  <input type="file" />
                  <div class="upload-inner">
                    <img src="./assets/images/ic-upload.svg" alt="Icon" />
                    <span>Upload Your Image</span>
                  </div>
                </div>
                <img src="./assets/images/layout-demo-3.jpg" alt="Image" class="small-img"
                  (click)="swapImages($event)" />
              </div>
              <div class="layer-div">
                <div class="upload-outer d-none">
                  <input type="file" />
                  <div class="upload-inner">
                    <img src="./assets/images/ic-upload.svg" alt="Icon" />
                    <span>Upload Your Image</span>
                  </div>
                </div>
                <img src="./assets/images/layout-demo-4.jpg" alt="Image" class="small-img"
                  (click)="swapImages($event)" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- List Highlight Block  -->
      <div class="post-comp-block editable">
        <div class="drop-thumb-wrapper">
          <div class="highlight-list-block">
            <h3>Header 2</h3>
            <ul>
              <li>
                <span class="text-layer bg-added"> Hamza Blackwell </span>
                <button class="btn btn-highlight" (click)="openAddHighlightModal(addHighlightModal)">
                  <img src="./assets/images/ic-marker.svg" alt="Icon" />
                  <span>Add highlight</span>
                </button>

              </li>
              <li>
                <span class="text-layer"> Ray Oneill </span>
              </li>
              <li>
                <span class="text-layer"> Hailey Sosa </span>
              </li>
              <li class="cus-tooltip tooltip-effect-1">
                <span class="text-layer"> Dillon Booker </span>
                <span class="tooltip-content">
                  Dillon Booker
                </span>
              </li>
            </ul>
            <!-- <ul>
              <li>
                <span class="text-layer bg-added"> Hamza Blackwell </span>
                <ul>
                  <li>
                    <span class="text-layer bg-added"> Hamza Blackwell </span>
                  </li>
                  <li>
                    <span class="text-layer"> Ray Oneill </span>
                  </li>
                  <li>
                    <span class="text-layer"> Hailey Sosa </span>
                  </li>
                  <li>
                    <span class="text-layer"> Dillon Booker </span>
                  </li>
                </ul>
              </li>
              <li>
                <span class="text-layer"> Ray Oneill </span>
              </li>
              <li>
                <span class="text-layer"> Hailey Sosa </span>
              </li>
              <li>
                <span class="text-layer"> Dillon Booker </span>
              </li>
            </ul> -->
          </div>
          <div class="cta-block">
            <button class="btn" title="Edit">
              <!-- <img src="./assets/images/ic-setting.svg" alt="Icon" /> -->
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.1 7.06436L15.7934 6.78032C15.6798 6.43246 15.5391 6.09317 15.3729 5.76633L16.0963 4.64118C16.2254 4.44015 16.197 4.17621 16.0282 4.00734L13.9927 1.97183C13.8238 1.80296 13.5599 1.77456 13.3588 1.90374L12.2337 2.62708C11.9068 2.46093 11.5675 2.32021 11.2197 2.20659L10.9356 0.899994C10.8849 0.666534 10.6782 0.5 10.4393 0.5H7.56072C7.32182 0.5 7.11507 0.666534 7.06436 0.899994L6.78032 2.20659C6.43246 2.32021 6.09317 2.46093 5.76633 2.62708L4.64118 1.90374C4.44015 1.77456 4.17621 1.80296 4.00734 1.97183L1.97183 4.00734C1.80296 4.17621 1.77456 4.44015 1.90374 4.64118L2.62708 5.76633C2.46093 6.09317 2.32021 6.43246 2.20659 6.78032L0.899994 7.06436C0.666534 7.1152 0.5 7.32182 0.5 7.56072V10.4393C0.5 10.6782 0.666534 10.8848 0.899994 10.9356L2.20659 11.2197C2.32021 11.5675 2.46093 11.9068 2.62708 12.2337L1.90374 13.3588C1.77456 13.5599 1.80296 13.8238 1.97183 13.9927L4.00734 16.0282C4.17621 16.197 4.44015 16.2254 4.64118 16.0963L5.76633 15.3729C6.09317 15.5391 6.43246 15.6798 6.78032 15.7934L7.06436 17.1C7.11507 17.3335 7.32182 17.5 7.56072 17.5H10.4393C10.6782 17.5 10.8849 17.3335 10.9356 17.1L11.2197 15.7934C11.5675 15.6798 11.9068 15.5391 12.2337 15.3729L13.3588 16.0963C13.5599 16.2254 13.8238 16.1972 13.9927 16.0282L16.0282 13.9927C16.197 13.8238 16.2254 13.5599 16.0963 13.3588L15.3729 12.2337C15.5391 11.9068 15.6798 11.5675 15.7934 11.2197L17.1 10.9356C17.3335 10.8848 17.5 10.6782 17.5 10.4393V7.56072C17.5 7.32182 17.3335 7.1152 17.1 7.06436ZM12.0478 9C12.0478 10.6805 10.6805 12.0478 9 12.0478C7.31948 12.0478 5.95219 10.6805 5.95219 9C5.95219 7.31948 7.31948 5.95219 9 5.95219C10.6805 5.95219 12.0478 7.31948 12.0478 9Z"
                  fill="currentColor" />
              </svg>

            </button>
            <button class=" btn btn-delete" title="Delete" (click)="openDeleteSectionModal(deleteSectionModal)">
              <!-- <img src="./assets/images/ic-delete.svg" alt="Icon" /> -->
              <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.5938 1.75H8.1875V1.3125C8.1875 0.587617 7.59988 0 6.875 0H5.125C4.40012 0 3.8125 0.587617 3.8125 1.3125V1.75H1.40625C0.802199 1.75 0.3125 2.2397 0.3125 2.84375V3.71875C0.3125 3.96039 0.508363 4.15625 0.75 4.15625H11.25C11.4916 4.15625 11.6875 3.96039 11.6875 3.71875V2.84375C11.6875 2.2397 11.1978 1.75 10.5938 1.75ZM4.6875 1.3125C4.6875 1.07133 4.88383 0.875 5.125 0.875H6.875C7.11617 0.875 7.3125 1.07133 7.3125 1.3125V1.75H4.6875V1.3125Z"
                  fill="currentColor" />
                <path fill-rule=" evenodd" clip-rule="evenodd"
                  d="M1.00602 5.17448C1.0023 5.09649 1.06451 5.03125 1.14257 5.03125H10.857C10.9351 5.03125 10.9973 5.09649 10.9936 5.17448L10.6327 12.7498C10.5993 13.4509 10.0234 14 9.3218 14H2.67781C1.97617 14 1.40031 13.4509 1.36696 12.7498L1.00602 5.17448ZM7.73068 8.30868L6.21478 8.2179L6.72427 7.9245L6.08254 6.87886L5.01157 8.76953L3.75658 8.05899L4.74215 6.31805C4.83876 6.14748 5.05976 6.0372 5.34667 6.0233C6.04802 5.98945 7.18511 6.00245 7.18511 6.00245L7.95012 7.22158L8.45758 6.93086L7.73068 8.30868ZM4.9071 10.1633L4.37251 9.84775L3.77875 10.9214L5.95139 10.9221V12.3642H3.95112C3.75454 12.3642 3.54967 12.2266 3.39658 11.9836C3.02204 11.3892 2.47266 10.3935 2.47266 10.3935L3.15675 9.12735L2.65377 8.82901L4.21135 8.78261L4.9071 10.1633ZM9.47243 9.97713L8.52093 8.21759L7.2525 8.90392L8.28513 10.8152L7.05839 10.8033L7.07677 10.2477L6.19812 11.452L6.97971 12.8L7.0028 12.2159L8.44226 12.2152C8.44226 12.2152 9.05686 11.2581 9.40093 10.6462C9.54236 10.3958 9.5659 10.1504 9.47243 9.97713Z"
                  fill="currentColor" />
              </svg>


            </button>
          </div>
        </div>
      </div>

      <!-- Main Image with social data Block  -->
      <div class="post-comp-block">
        <div class="drop-thumb-wrapper">
          <div class="img-drop-block edit-mode">
            <div class="mockup-info-block">
              <div class="post-uploader-data">
                By
                <div class="block">
                  <img src="../assets/images/ic-card-uploader.png" alt="User" />
                  Annabelle Washington
                </div>
              </div>
              <div class="card-watch-data">
                <span class="profile-tag">Public</span>
                <ul>
                  <li>
                    <img src="../assets/images/ic-comments.svg" alt="Icon" />
                    2.8k
                  </li>
                  <li>
                    <img src="../assets/images/ic-card-arrow-up.svg" alt="Icon" />
                    12.7k
                  </li>
                  <li>
                    <img src="../assets/images/ic-card-arrow-down.svg" alt="Icon" />
                    1.7k
                  </li>
                </ul>
              </div>
            </div>
            <div class="mockup-wrap">
              <img src="./assets/images/article-post-1.webp" alt="Mockup" class="main-img" />
            </div>
          </div>
        </div>
      </div>

      <!-- Like Dislike Button Block  -->

      <div class="like-cta-block">
        <div class="block">
          <input type="radio" name="like-cta" id="btn-like" checked />
          <label for="btn-like">
            <div class="svg-wrap">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 9V21C0 21.8284 0.671539 22.5 1.5 22.5H6V7.5H1.5C0.671539 7.5 0 8.17154 0 9Z"
                  fill="currentColor" />
                <path
                  d="M21.23 8.9999H16.7988C16.4114 8.9999 16.2173 8.74135 16.1521 8.63002C16.0869 8.51943 15.9551 8.22426 16.1426 7.88588L17.7048 5.07265C18.0476 4.45668 18.0828 3.73231 17.8022 3.08558C17.5217 2.43812 16.968 1.96864 16.2832 1.79798L15.1816 1.52259C14.9136 1.45521 14.6294 1.5409 14.4426 1.74818L8.46167 8.39271C7.84131 9.08339 7.5 9.97402 7.5 10.9013V18.7499C7.5 20.8175 9.18237 22.4999 11.25 22.4999L18.7112 22.4992C20.3958 22.4992 21.8833 21.3646 22.3279 19.7408L23.9289 12.3932C23.9758 12.1888 24 11.9794 24 11.7699C24 10.2428 22.7571 8.9999 21.23 8.9999Z"
                  fill="currentColor" />
              </svg>
            </div>
            <span class="text"> Like </span>
          </label>
        </div>
        <div class="block">
          <input type="radio" name="like-cta" id="btn-dislike" />
          <label for="btn-dislike" class="label-dislike">
            <div class="svg-wrap">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 9V21C0 21.8284 0.671539 22.5 1.5 22.5H6V7.5H1.5C0.671539 7.5 0 8.17154 0 9Z"
                  fill="currentColor" />
                <path
                  d="M21.23 8.9999H16.7988C16.4114 8.9999 16.2173 8.74135 16.1521 8.63002C16.0869 8.51943 15.9551 8.22426 16.1426 7.88588L17.7048 5.07265C18.0476 4.45668 18.0828 3.73231 17.8022 3.08558C17.5217 2.43812 16.968 1.96864 16.2832 1.79798L15.1816 1.52259C14.9136 1.45521 14.6294 1.5409 14.4426 1.74818L8.46167 8.39271C7.84131 9.08339 7.5 9.97402 7.5 10.9013V18.7499C7.5 20.8175 9.18237 22.4999 11.25 22.4999L18.7112 22.4992C20.3958 22.4992 21.8833 21.3646 22.3279 19.7408L23.9289 12.3932C23.9758 12.1888 24 11.9794 24 11.7699C24 10.2428 22.7571 8.9999 21.23 8.9999Z"
                  fill="currentColor" />
              </svg>
            </div>
            <span class="text"> Dislike </span>
          </label>
        </div>
      </div>

      <p class="block-tooltip" title="Hello World">Your Data Here</p>
    </section>
  </div>
</div>

<!-- Delete Section Modal -->
<ng-template #deleteSectionModal let-modal>
  <div class="modal-head">
    <button class="btn btn-close" (click)="modal.close('Close click')"></button>
  </div>
  <div class="modal-body">
    <div class="img-wrap">
      <img src="./assets/images/ic-delete-section.svg" alt="Icon" />
    </div>
    <h2 class="title-text" ngbAutofocus>
      Are you sure, want to delete this section?
    </h2>
    <h5 class="info-text">
      By deleting this section, you will also loose the content attached to
      this.
    </h5>
    <div class="btn-grps">
      <button class="btn btn-outline-danger" title="Delete">Delete</button>
    </div>
  </div>
</ng-template>

<!-- Layout selection modal -->
<ng-template #layoutSelect let-modal>
  <div class="drop-head">
    <h4 class="drop-title" id="modal-basic-title">Choose Layout</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"
      title="Close Modal"></button>
  </div>
  <div class="drop-body">
    <div class="row">
      <div class="col-4">
        <input type="radio" name="select-img-grid" id="layout-1" checked />
        <label for="layout-1" class="form-label">
          <div class="preview-layout-block view-1" ngbAutofocus>
            <img src="./assets/images/grid-view-1.jpg" alt="View" />
          </div>
        </label>
      </div>
      <div class="col-4">
        <input type="radio" name="select-img-grid" id="layout-2" />
        <label for="layout-2" class="form-label">
          <div class="preview-layout-block view-2">
            <img src="./assets/images/grid-view-2.jpg" alt="View" />
          </div>
        </label>
      </div>
      <div class="col-4">
        <input type="radio" name="select-img-grid" id="layout-3" />
        <label for="layout-3" class="form-label">
          <div class="preview-layout-block view-3">
            <img src="./assets/images/grid-view-3.jpg" alt="View" />
          </div>
        </label>
      </div>
    </div>
  </div>
</ng-template>

<!-- Add highlight Modal -->
<ng-template #addHighlightModal let-modal>
  <div class="drop-head">
    <h4 class="drop-title">Add Highlight</h4>
    <button class="btn btn-close" (click)="modal.close('Close click')"></button>
  </div>
  <div class="drop-body">
    <div class="text-view-block">
      <span> - Hamza Blackwell </span>
    </div>
    <div class="NgxEditor__Wrapper">
      <ngx-editor [editor]="editor" [ngModel]="html" [disabled]="false" [placeholder]="'Type here...'"></ngx-editor>
    </div>
  </div>
  <div class="drop-footer">
    <div>
      <!-- <button class="btn btn-text btn-single" title="Bold">B</button>
        <button class="btn btn-text fst-italic btn-single" title="Italic" disabled>
          I
        </button> -->
      <ngx-editor-menu [editor]="editor" [toolbar]="highLightTootlbar" [dropdownPlacement]="'bottom'">
      </ngx-editor-menu>
    </div>
    <div>
      <button class="btn btn-text" title="Cancel" ngbAutofocus>Cancel</button>
      <button class="btn btn-outline-secondary" title="Add">Add</button>
    </div>
  </div>
</ng-template>

<!-- Discard Changes Modal -->
<ng-template #discardChangesModal let-modal>
  <div class="modal-head">
    <button class="btn btn-close" (click)="modal.close('Close click')"></button>
  </div>
  <div class="modal-body">
    <div class="img-wrap">
      <img src="./assets/images/ic-delete-section.svg" alt="Icon" />
    </div>
    <h2 class="title-text" ngbAutofocus>
      Are you sure, you want to discard the changes?
    </h2>
    <div class="btn-grps">
      <button class="btn btn-outline-primary" title="No" (click)="modal.close('Close click')">No</button>
      <button class="btn btn-primary" title="Yes">Yes</button>
    </div>
  </div>
</ng-template>